import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import './assets/css/base.css'
import './assets/css/custom.css'
import './assets/css/style.css'
import './assets/css/global.css'

import './assets/js/custom'
import "./assets/js/global"
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import AlertOptions from './constants/AlertOptions';
import store from './redux/store';
import { Provider } from 'react-redux';

ReactDOM.render(
  <React.StrictMode>
   <Provider store={store}>
    <AlertProvider template={AlertTemplate} {...AlertOptions}>
      <App />
    </AlertProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
